import Icon from '../Icon.vue'

Icon.register({
  'menu_home': {
    width: 16,
    height: 16,
    paths: [
      {
        d: 'M8.99259 14.8571C8.99259 15.5385 9.40137 16 9.98524 16H12.9632C13.5482 16 13.9558 15.5385 13.9558 14.8571V10.413L7.99998 4.45712L2.04408 10.413V14.8571C2.04867 15.5332 2.45514 16 3.03672 16H6.01466C6.59739 16 7.00272 15.5332 7.0073 14.8571L7.01471 11H9L8.99259 14.8571Z'
      },
      {
        d: 'M1.29772 9.74516L7.99998 3.04291L14.7355 9.77847H14.9485C15.3844 9.77847 15.7817 9.61487 15.9411 9.14286C16.1006 8.66818 15.92 7.98108 15.5942 7.63841L8.68182 0.320844C8.27689 -0.10717 7.65861 -0.10717 7.25483 0.322177L0.403198 7.59707C0.0808625 7.93975 -0.100661 8.66818 0.0587864 9.14286C0.215939 9.61487 0.680796 9.73714 1.11784 9.73714L1.29772 9.74516Z'
      }
    ]
  }
})
